
/**
 * Palvelinsiirron johdosta pakotetaan toistaiseksi
 */
window.artestBaseDomain = "artest.net";
window.artestRootDomain = location.protocol + "//" + window.artestBaseDomain;
window.artestApiDomain  = location.protocol + "//api.artest.net";
/******/

if (window.artestBaseDomain == null || window.artestRootDomain == null || window.artestApiDomain == null) { 
	//if (location.host.match(/artest\.net/)) {
	if (location.host.match( /^(((?!\-))(xn\-\-)?[a-z0-9\-_]{0,61}[a-z0-9]{1,1}\.)*(xn\-\-)?([a-z0-9\-]{1,61}|[a-z0-9\-]{1,30})\.[a-z]{2,}$/ )) {
		window.artestBaseDomain = (location.host.match(/dev\.artest\.net/)==null ? "artest.net" : "dev.artest.net");
		window.artestRootDomain = "https://" + window.artestBaseDomain;
		window.artestApiDomain = "https://api." + window.artestBaseDomain;
	} else {
		window.artestBaseDomain = location.host;
		window.artestRootDomain = location.protocol + "//" + window.artestBaseDomain;
		window.artestApiDomain = location.protocol + "//"+ location.host.match(/([^:]+)(:\d+)?/)[1] + ":1337";
	}
}

try {
	if (!document.querySelector( "script[src='/analytics/analytics.js']" )) (function( elem ) {
		document.head.appendChild( elem );
		elem.async = true;
		elem.src   = "/analytics/analytics.js";
	})(document.createElement( "script" ));
} catch (e) {}

var ApiHandler = angular.module("ApiHandler", [])

.provider("$ApiHandler", function(){
	var self = this;

	this.path = (function(){
		if (window.artestApiDomain) return window.artestApiDomain;

		if (window.api_url) return window.api_url;

		else if (window.api_host) {
			return "https://"+ window.api_host;
		} else if (location.host.match(/localhost/)) {
			return "https://localhost:1337";
		}

		return "https://"+(((location.host.match(/dev\.artest\.net$/) == null && location.host.match(/artest\.net$/) != null) ? "api.artest.net" : "api.dev.artest.net"));
	})() +"/v2";


	this.config = function(config) {
		if (typeof config == "string") return this.config({ path : config });
		this.path = config.path || this.path;
	}

	this.params_get = function(resource, params, data, opts) {
		params = params || {};
		data = data || null;
		opts = opts || {};
		opts.path    = typeof opts.path == "undefined" ? this.path : opts.path;
		opts.url     = opts.path + resource;
		opts.method  = opts.method  || "GET";
		opts.data    = opts.data    || data;
		opts.headers = opts.headers || {};
		opts.params  = opts.params  || params;
		if( typeof opts.params == "object" && typeof opts.params.where == "object" ){
			opts.params.where = JSON.stringify( opts.params.where );
		}

		var authorization;
		if (!!(authorization = self.ipCookie("authorization"))) {
			opts.headers["authorization"] = authorization;
		}

		return opts
	};
	this.params_post = function(resource, params, data, opts) {
		opts = opts || {};
		opts.method = opts.method || "POST";
		return this.params_get(resource, params, data, opts);
	};
	this.params_delete = function(resource, params, data, opts) {
		opts = opts || {};
		opts.method = opts.method || "DELETE";
		opts.headers = opts.headers || {};
		opts.headers["Content-Type"] = opts.headers["Content-Type"] || "application/json";

		return this.params_post(resource, params, data, opts);
	};

	this.$get = ['$http', 'Notification', 'ipCookie', function($http, Notification, ipCookie) {
		self.ipCookie = ipCookie;

		function $httpRun(params) {
			return $http(params)
			.catch(function(e){
				if (e) {
					if (e.status == -1) {
						if (window.artestBaseDomain != "artest.net") {
							Notification.error("UNKNOWN Status from API! Is API down or problems with certificates?");
						}
					} else if (e.status == 502) { // Bad Gateway
						if (window.artestBaseDomain != "artest.net") {
							Notification.error("API responses with 502 Bad Gateway! API Api down?");
						}
					} if (e.status == 504) { // Gateway Timeout
						if (window.artestBaseDomain != "artest.net") {
							Notification.error("API responses with 504 Gateway Timeout! Is API down?");
						}
					}
					if( e.headers ){
						console.error( "Error while "+e.headers.method+"'n "+e.headers.url+" from API", params, e );
					} else {
						console.error( e );
					}
				}
				throw e;
			});
		}

		return {
			get : function(resource, params, data, opts) {
				return $httpRun(self.params_get.apply(self, arguments));
			},
			post : function(resource, params, data, opts) {
				console.debug("$ApiHandler.post", resource, params, data, opts);

				return $httpRun(self.params_post.apply(self, arguments))
					.catch(function(e){ Notification.error({title:"Error while GET'n "+resource+" from API",message:(!!e.data&&!!e.data.str)?e.data.str:e.statusText}); throw e; });
			},
			delete : function(resource, params, data, opts) {
				console.debug("$ApiHandler.delete", resource, params, data, opts);

				return $httpRun(self.params_delete.apply(self, arguments))
					.catch(function(e){ Notification.error({title:"Error while GET'n "+resource+" from API",message:(!!e.data&&!!e.data.str)?e.data.str:e.statusText}); throw e; });
			},
			getOfClient : function(resource, params, data, opts) {
				var client_uid;
				if (!!client_uid) arguments[0] = "/clients/"+ client_uid + arguments[0];
				else throw new Error("No client credentials available");

				return $http(self.params_get.apply(self, arguments))
						.catch(function(e){ console.error("Error while GET'n "+resource+" from API", arguments, e); Notification.error({title:"Error while GET'n "+resource+" from API",message:(!!e.data&&!!e.data.str)?e.data.str:e.statusText}); throw e;});
			},
			clearAuthorization : function() {
				if (localStorage && localStorage.removeItem) {
					localStorage.removeItem("api/users/me");
				}

				self.ipCookie.remove("authorization", { domain : ".artest.net", path : "/" });
				self.ipCookie.remove("access_token",  { domain : ".artest.net", path : "/" });

				self.ipCookie.remove("authorization", { path : "/" });
				self.ipCookie.remove("access_token",  { path : "/" });
			},
			getAuthorization : function() {
				return self.ipCookie("authorization");
			},
			getParsedLocation : function( response ) {
				var parser = document.createElement('a');
				parser.href = response.headers("Location");
				return parser;
			},
			buildBodyGenerator: function( prefix, handlers ) {
		        prefix = prefix || null; 

		        var handlerFns = {};
		        for( var key in handlers ) {
		            if( typeof handlers[key] == "function" ) {
						handlerFns[ key ] = handlers[ key ];
					} else {
		                handlerFns[ key ] = (function( _default ){
		                    return function( value ){ return value || _default; };
		                })( handlers[ key ] );
		            }
		        }
				var handlerKeys = Object.keys( handlerFns );

		        return function( data, ret ) {
					data = data || {};
		            ret  = ret  || {};
					var keys = handlerKeys.concat( Object.keys( data )).filter(function(v,i,a){ return a.indexOf(v)==i; });
					for (var i in keys) {
						var key = keys[i], nkey = (prefix ? prefix + "." : "" ) + key;
		                ret[ nkey ] = handlerFns[ key ] ? handlerFns[ key ]( data[ key ], ret ) : data[ key ];
		            }
		            return ret;
		        };
		    }
		}
	}];
});
